// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__emCZ0","text":"styles_text__E-rKc"};